export default class DadosIniciais {
    constructor(formulario = '') {
        this.farm = formulario.farm;
        this.city = formulario.city;
        this.state = formulario.state;
        this.size = formulario.size;
    }
}